import { connect } from 'react-redux';
import { NotificationFolderWatcherType } from '../../../notification.types';
import { StateType } from '../../../../../state/state.types';

const mapState = (
  { notifications }: StateType,
  { notification }: { notification: NotificationFolderWatcherType },
) => ({
  isAlreadyRead: !!notifications.notifReadStatusMap[notification.id],
});

export const Connect = connect(mapState);
